// Identifies which deployed environment this build is running against.
// Cookies set by the Ties node server are env-scoped (e.g., token.cert,
// userDivisions.cert) so the shared .rtd-denver.com cookie domain doesn't
// cause dev/cert/prod to share auth state. We derive the env from
// REACT_APP_API_URL because that var already varies per deployment.
const url = process.env.REACT_APP_API_URL || "";

export const ENV = (() => {
  if (url.includes("localhost")) return "local";
  if (url.includes("ties-node-prod.")) return "prod";
  if (url.includes("ties-node-cert.")) return "cert";
  if (url.includes("ties-node-dev.")) return "dev";
  return "unknown";
})();
